/**
 * Customers whose portal shows SAMPLE data. Gated on the signed-in user's
 * custom:customerId at runtime — never a build flag — so the same build serves
 * real customers without the "Demo account" tag and the demo login always with it.
 * TRIUMPH_SHEETS is the demo login's customerId; its fleet is the synthetic
 * demo-motor-01..09 (source:'synthetic-demo'). Required before any prospect
 * sees the portal: sample data is never presented as a real plant.
 */
export const SAMPLE_DATA_CUSTOMER_IDS = new Set(['TRIUMPH_SHEETS']);

export function isSampleDataCustomer(customerId) {
  return SAMPLE_DATA_CUSTOMER_IDS.has(customerId);
}
